export default __webpack_public_path__ + "static/media/newsletter_purple2.9bc33520.png";